import * as React from 'react';
import assign = require('lodash/assign'); // tslint:disable-line: no-require-imports
import find = require('lodash/find'); // tslint:disable-line: no-require-imports
import TreeView, {TreeViewExpandedState, TreeViewErrorState} from './treeview/TreeView';
import {getFileTree} from './treeview/pathUtils';

interface AssetListProps {
	paths: string[];
	editingPath: string;
	fontSizeAdjustment: number;
	errorState?: TreeViewErrorState;
	onClickFile(path: string): void;
}

interface AssetListState {
	expandedState: TreeViewExpandedState;
}

const DEFAULT_FILE_ICON = 'file-o';

const FILE_ICONS: {[pattern: string]: string} = {
	'config\\.json$': 'cog',
	'dictionary\\.json$': 'book',
	'\\.formula$': 'flask',
	'\\.template$': 'file-code-o',
	'\\.form\\.json$': 'edit',
	'\\.card\\.json$': 'credit-card',
	'\\test_users\\.json$': 'user',
	'\\roles\\.json$': 'users',
	'\\.json': 'file-code-o',
	'\\.html': 'file-code-o',
	'\\.csv': 'table',
	'\\.liquid$': 'file-code-o',
};

function getFileIcon(path: string): string {
	const key: string = find(Object.keys(FILE_ICONS), (pattern: string) => new RegExp(pattern).test(path));
	return key ? FILE_ICONS[key] : DEFAULT_FILE_ICON;
}

function toggleExpandedState(state: TreeViewExpandedState, path: string): TreeViewExpandedState {
	return assign<{}, TreeViewExpandedState, {}>
		({}, state, {[path]: !state[path]});
}

export default class AssetList extends React.Component<AssetListProps, AssetListState> {

	public state: AssetListState = {
		expandedState: {},
	};

	constructor(props: AssetListProps, context: any) {
		super(props, context);
		this.handleClickDirectory = this.handleClickDirectory.bind(this);
	}

	public render() {
		return <TreeView
			fontSizeAdjustment={this.props.fontSizeAdjustment}
			editingPath={this.props.editingPath}
			node={getFileTree(this.props.paths)}
			expandedState={this.state.expandedState}
			errorState={this.props.errorState}
			onClickDirectory={this.handleClickDirectory}
			onClickFile={this.props.onClickFile}
			getFileIcon={getFileIcon}
			className='asset-list'
		/>;
	}

	private handleClickDirectory(path: string) {
		this.setState({expandedState: toggleExpandedState(this.state.expandedState, path)});
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-editor/AssetList.tsx